import { defineElement, html, TemplateElement, when } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-accordion-group/e-banking-accordion-group.js';

class EditableAccordionGroup extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    injectProperties() {
        return { mgnlContext: null };
    }

    get headline() {
        return this.content?.headline || '';
    }

    template() {
        // class="${this.mgnlContext?.isMagnoliaEdit === true ? 'pointer-events-none' : ''}"
        return html`
            ${when(
                !this.mgnlContext?.isMagnoliaEdit,
                html`
                    <mb-e-banking-accordion-group headline="${this.headline}">
                        <mgnl-editable-area .content="${this.content?.accordionElements}"></mgnl-editable-area>
                    </mb-e-banking-accordion-group>
                `,
                html`<h2 class="text-xl font-medium text-green-medium mb-8">${this.headline}</h2>
                    <mgnl-editable-area .content="${this.content?.accordionElements}"></mgnl-editable-area> `,
            )}
        `;
    }
}

defineElement('editable-accordion-group', EditableAccordionGroup);
